import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormBuilderDraft,
  BackendMutationNameLongFormBuilderDraftArgs,
} from 'src/types/backend';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation NameLongFormBuilderDraft($projectId: ID!, $draftId: ID!, $name: String!) {
    nameLongFormBuilderDraft(projectId: $projectId, draftId: $draftId, name: $name) {
      ...LongFormBuilderDraft
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

type Variables = BackendMutationNameLongFormBuilderDraftArgs;
type Result = BackendLongFormBuilderDraft;

export const nameLongFormBuilderDraft = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
